import { ItemPurchaseOrderRequest } from '@ce-openapi/shadow-proxy-purchase-order-ts-axios-client';
import { PopulateDataItemRequestPayload } from '../types/purchaseOrder/form';

const generateShadowProxyItem = (
  data: PopulateDataItemRequestPayload,
  supplierId = ''
): ItemPurchaseOrderRequest => {
  return {
    id: data.purchase_order.external_transaction_uuid,
    is_advanced: false,
    note: data.purchase_order.note,
    order_no: data.purchase_order.order_no,
    supplier_id: supplierId,
    item_purchase_order_detail: data.purchase_order.history_details.map(
      (detail) => ({
        ...detail,
        begin_stock: detail.beginning_stock,
        item_category_id: detail.item_category_id,
        item_category_name: detail.item_category_name,
        cost: detail.price,
      })
    ),
  };
};

export default generateShadowProxyItem;
